<template>
    <Base>
        <v-card-title class="text-center d-block">
            <span class="t-color-brand-medium-base">Esqueceu sua senha?</span>
        </v-card-title>
        <v-card-text>
            <div class="text-center mb-3">
                Informe seu e-mail para recuperar sua senha.
            </div>
            <v-text-field
                label="E-mail"
                v-model="email"
                outlined
                dense
                required
            ></v-text-field>

            <div class="d-flex justify-space-between">
                <cp-button
                    color="secondary"
                    type="button"
                    :disabled="saving"
                    :loading="saving"
                    :href="route('login')"
                >
                    Login
                </cp-button>
                <cp-button
                    color="primary"
                    type="submit"
                    :disabled="saving"
                    :loading="saving"
                    @click="submit"
                    class="ml-5"
                >
                    Recuperar senha
                </cp-button>
            </div>
        </v-card-text>
    </Base>
</template>

<script>
import Base from '@components/common/Base'

export default {
    data: () => ({
        saving: false,
        email: '',
    }),

    metaInfo: () => ({
        title: 'Esqueceu sua senha?'
    }),

    components: {
        Base
    },

    methods: {
        submit() {
            this.saving = true;

            axios.post(this.route('password.email'), {
                email: this.email,
            })
            .then((res) => {
                this.$bus.$emit('feedback', {
                    message: res.data.message,
                });

            }).catch((error) => {
                if (this.errorFeedback(error) == 422) {
                    let errorMessage = error.response.data.errors != undefined
                        ? error.response.data.errors
                        : error.response.data

                    console.log('error', errorMessage)
                }
            }).finally(() => {
                this.saving = false;
            })
        },
    }
}
</script>